
/**
 * @param {string} action
 * @param {any} data
 *
 * @return {Promise<Response>}>
 */
export function nuAjax( action, data ) {
    data.nonce = Nu.ajax.nonce;
    const res = fetch( `${Nu.ajax.url}?action=${action}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify( data )
    } );

    return res;
}